export const ru = {
    'hint_search-error': 'Ошибка',
    'hint_search-in-progress': 'Идёт поиск…',
    'hint_search-results': 'Найдено документов: {{count}}',
    'search-author-suggest-no-results': 'По запросу «{{query}}» ничего не найдено',
    'search-empty-results': 'Ничего не найдено',
    'search-error': 'Не удалось загрузить данные',
    'search-filters': 'Фильтры',
    'search-filters-author': 'Автор страницы',
    'search-filters-author-it-is-you': 'это вы',
    'search-filters-author-me': 'Автор — я',
    'search-filters-author-suggest-placeholder': 'Введите имя сотрудника',
    'search-filters-clear-all': 'Очистить все',
    'search-filters-creation-date': 'Дата создания',
    'search-filters-data-range-placeholder': 'Выберите дату',
    'search-filters-date': 'Дата',
    'search-filters-date-range-this-month': 'За месяц',
    'search-filters-date-range-this-week': 'За неделю',
    'search-filters-date-range-this-year': 'За год',
    'search-filters-date-range-today': 'За сегодня',
    'search-filters-document-type': 'Тип документа',
    'search-filters-document-type-all': 'Все',
    'search-filters-document-type-file': 'Файл',
    'search-filters-document-type-grid': 'Таблица',
    'search-filters-document-type-page': 'Страница',
    'search-filters-modification-date': 'Дата изменения',
    'search-filters-section': 'Раздел',
    'search-filters-section-current-page': 'текущий',
    'search-filters-section-help-tooltip': 'Введите адрес раздела относительно главной страницы Wiki. Например, для поиска по всем подстраницам раздела https://wiki.yandex.ru/my-project/plan введите my-project/plan.',
    'search-filters-section-input-placeholder': 'Введите адрес страницы',
    'search-filters-show-obsolete': 'Показывать устаревшие страницы',
    'search-indexing-error-description': 'Поисковый индекс для вашей базы знаний ещё не готов. Попробуйте повторить поиск позже.',
    'search-indexing-error-title': 'Индексируем вики-страницы',
    'search-placeholder': 'Поиск',
    'search-result-item-changed': 'Изменено',
    'search-results': 'Результаты по запросу',
    'search-show-more': 'Показать еще',
    'search-sorting-change-date': 'По дате изменения',
    'search-sorting-creation-date': 'По дате создания',
    'search-sorting-relevancy': 'По релевантности'
};
